"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _Error = _interopRequireDefault(require("@quintoandar/cozy-icons/Error"));
var Styles = _interopRequireWildcard(require("./ValidationErrors.styles"));
var _proptypes = _interopRequireDefault(require("../Input/proptypes"));
var _messages = _interopRequireDefault(require("./messages"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var ValidationErrors = function ValidationErrors(_ref) {
  var id = _ref.id,
    _ref$errors = _ref.errors,
    errors = _ref$errors === void 0 ? [] : _ref$errors,
    variant = _ref.variant,
    intl = _ref.intl;
  var displayableErrors = errors.filter(Boolean);
  if (!displayableErrors) return null;
  return /*#__PURE__*/_react["default"].createElement(Styles.ErrorWrapper, {
    hasError: displayableErrors.length,
    numberOfErrors: displayableErrors.length
  }, displayableErrors.map(function (error, index) {
    return /*#__PURE__*/_react["default"].createElement(Styles.ErrorLabel, {
      key: error,
      level: "captionStrong",
      "data-variant": variant
    }, /*#__PURE__*/_react["default"].createElement(Styles.InvisibleWrapper, {
      id: "".concat(id, "_").concat(index)
    }, "".concat(intl.formatMessage(_messages["default"].errorIconAriaLabel), " ").concat(error)), /*#__PURE__*/_react["default"].createElement(Styles.LabelWrapper, {
      "aria-hidden": true,
      "aria-labelledby": "".concat(id, "_").concat(index)
    }, /*#__PURE__*/_react["default"].createElement(_Error["default"], {
      size: "small"
    }), " ", error));
  }));
};
ValidationErrors.propTypes = process.env.NODE_ENV !== "production" ? {
  id: _propTypes["default"].string,
  errors: _propTypes["default"].arrayOf(_propTypes["default"].string),
  variant: _proptypes["default"],
  intl: _propTypes["default"].object
} : {};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)((0, _reactIntl.injectIntl)(ValidationErrors));